/**
 * MeasurementsCharts - Progress charts component
 * Displays weight, body fat, and muscle mass trends
 */

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useTranslation } from "@/hooks/useTranslation";
import type { ChartDataPoint } from "../types";

interface MeasurementsChartsProps {
  chartData: ChartDataPoint[];
}

export function MeasurementsCharts({ chartData }: MeasurementsChartsProps) {
  const { t } = useTranslation();

  if (!chartData || chartData.length === 0) return null;

  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle>{t("measurements:progressTrends")}</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="weight"
              stroke="#10b981"
              name={t("measurements:charts.weight")}
            />
            <Line
              type="monotone"
              dataKey="fat"
              stroke="#f59e0b"
              name={t("measurements:charts.bodyFat")}
            />
            <Line
              type="monotone"
              dataKey="muscle"
              stroke="#3b82f6"
              name={t("measurements:charts.muscle")}
            />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
